import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator';
import { ProductApi } from "@/apis";
import { cloneDeep } from "lodash-es";
import { DATETIME_FORMAT, PAYMENT_METHOD_CONST } from "@/constants/constants";
import { format, parseISO } from "date-fns";
export var INITIAL_ENTRY = {
    id: undefined,
    corporateID: undefined,
    customerID: undefined,
    customerName: undefined,
    status: undefined,
    paymentStatus: undefined,
    paymentMethod: undefined,
    comment: undefined,
    experienceRecord: undefined,
    totalAmount: undefined,
    purchaseList: [],
    memberID: undefined,
    memberName: undefined,
    startDateTime: undefined,
    endDateTime: undefined,
    scheduleIDs: [],
    paymentList: [],
};
export var INITIAL_CUSTOMER = {
    id: undefined,
    corporateID: undefined,
    email: undefined,
    name: undefined,
    nameKana: undefined,
    phone: undefined,
    postCode: undefined,
    address: undefined,
    customerType: undefined,
    coupons: [],
};
var EntryForm = /** @class */ (function (_super) {
    __extends(EntryForm, _super);
    function EntryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.product = null;
        _this.subProduct = null;
        _this.comment = '';
        _this.customer = cloneDeep(INITIAL_CUSTOMER);
        _this.memberID = null;
        _this.valid = true;
        _this.message = '';
        return _this;
    }
    Object.defineProperty(EntryForm.prototype, "getStartDate", {
        get: function () {
            var _a;
            if ((_a = this.schedule) === null || _a === void 0 ? void 0 : _a.startDateTime) {
                var startDateTime = parseISO(this.schedule.startDateTime);
                return "" + format(startDateTime, DATETIME_FORMAT.YYYYMMDD_HHMM_JP);
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm.prototype, "getPlaceName", {
        get: function () {
            if (this.schedule) {
                return this.schedule.placeName;
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm.prototype, "getMemberName", {
        get: function () {
            if (this.schedule) {
                return this.schedule.memberName;
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm.prototype, "getPrice", {
        get: function () {
            if (this.product && this.product.prices) {
                return new Intl.NumberFormat('ja-JP').format(this.product.prices) + " \u5186";
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm.prototype, "validationRules", {
        get: function () {
            return {
                email: [
                    function (value) {
                        console.log("validationRules email " + value);
                        return !!value || 'メールアドレスを入力してください';
                    }
                ],
                name: [
                    function (value) {
                        console.log("validationRules name " + value);
                        return !!value || '氏名を入力してください';
                    }
                ],
                nameKana: [
                    function (value) {
                        console.log("validationRules name " + value);
                        return !!value || '氏名カナを入力してください';
                    }
                ],
                phone: [],
                postCode: [],
                address: [],
                memberID: [
                    function (value) {
                        console.log("validationRules memberID " + value);
                        return !!value || 'セラピストを選択してください';
                    }
                ],
            };
        },
        enumerable: false,
        configurable: true
    });
    EntryForm.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetForm();
                        _a = this;
                        return [4 /*yield*/, new ProductApi().getProductPublic({
                                id: this.productId,
                                corporateId: this.corporateId
                            }).then(function (res) { return res.data; })];
                    case 1:
                        _a.product = (_b.sent()) || {};
                        return [2 /*return*/];
                }
            });
        });
    };
    // selectMember(memberID: number) {
    //   console.log(`selectMember ${memberID}`)
    //   if (this.syncedTarget) {
    //     const schedule = this.syncedTarget.schedules.find(member => member.memberID === memberID)
    //     if (schedule) {
    //       this.schedule = schedule
    //     }
    //   }
    // }
    //
    EntryForm.prototype.selectSubProduct = function (subCode) {
        var _a, _b;
        this.subProduct = ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.subProducts) === null || _b === void 0 ? void 0 : _b.find(function (subProduct) { return subProduct.subCode === subCode; })) || null;
    };
    EntryForm.prototype.validateForm = function () {
        this.message = '';
        if (!this.$refs.entryForm.validate()) {
            this.message = '入力項目が不足しています';
            return;
        }
        console.log("validateForm ok " + this.valid);
        this.save();
    };
    EntryForm.prototype.save = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var entry;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!this.schedule || !this.schedule.id) {
                            alert("\u30BB\u30E9\u30D4\u30B9\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044");
                            return [2 /*return*/];
                        }
                        if (!this.customer.email) {
                            alert("\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
                            return [2 /*return*/];
                        }
                        if (!this.customer.name) {
                            alert("\u6C0F\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
                            return [2 /*return*/];
                        }
                        if (!this.customer.nameKana) {
                            alert("\u6C0F\u540D\u30AB\u30CA\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
                            return [2 /*return*/];
                        }
                        entry = cloneDeep(INITIAL_ENTRY);
                        entry.memberID = this.schedule.memberID;
                        entry.memberName = this.schedule.memberName;
                        entry.startDateTime = this.schedule.startDateTime;
                        entry.endDateTime = this.schedule.endDateTime;
                        entry.corporateID = this.corporateId;
                        entry.comment = this.comment;
                        entry.customer = this.customer;
                        entry.scheduleIDs = [this.schedule.id];
                        entry.mainProductID = (_a = this.product) === null || _a === void 0 ? void 0 : _a.id;
                        entry.mainProductName = (_b = this.product) === null || _b === void 0 ? void 0 : _b.name;
                        entry.placeID = this.schedule.placeID;
                        entry.placeName = this.schedule.placeName;
                        entry.purchaseList = [{
                                productID: (_c = this.product) === null || _c === void 0 ? void 0 : _c.id,
                                productName: (_d = this.product) === null || _d === void 0 ? void 0 : _d.name,
                                subCode: (_e = this.subProduct) === null || _e === void 0 ? void 0 : _e.subCode,
                                subProductName: (_f = this.subProduct) === null || _f === void 0 ? void 0 : _f.name,
                                price: (_g = this.product) === null || _g === void 0 ? void 0 : _g.prices,
                                quantity: 1,
                                amount: (_h = this.product) === null || _h === void 0 ? void 0 : _h.prices,
                            }],
                            entry.totalAmount = (_j = this.product) === null || _j === void 0 ? void 0 : _j.prices;
                        entry.paymentMethod = PAYMENT_METHOD_CONST.CARD;
                        // TODO ここでは保存せずにカード決済後に保存する
                        // entry = await new EntryApi().createEntry({
                        //   body: entry
                        // }).then(res => res.data)
                        return [4 /*yield*/, this.applied(entry)];
                    case 1:
                        // TODO ここでは保存せずにカード決済後に保存する
                        // entry = await new EntryApi().createEntry({
                        //   body: entry
                        // }).then(res => res.data)
                        _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EntryForm.prototype.applied = function (entry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, entry];
            });
        });
    };
    EntryForm.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'cal'];
            });
        });
    };
    EntryForm.prototype.resetForm = function () {
        if (this.$refs.entryForm) {
            this.$refs.entryForm.resetValidation();
        }
    };
    __decorate([
        Prop()
    ], EntryForm.prototype, "corporateId", void 0);
    __decorate([
        Prop()
    ], EntryForm.prototype, "productId", void 0);
    __decorate([
        PropSync('target', { type: Object })
    ], EntryForm.prototype, "schedule", void 0);
    __decorate([
        Emit('applied')
    ], EntryForm.prototype, "applied", null);
    __decorate([
        Emit('push')
    ], EntryForm.prototype, "cancel", null);
    EntryForm = __decorate([
        Component({})
    ], EntryForm);
    return EntryForm;
}(Vue));
export default EntryForm;
